import React, { useEffect, useState } from "react";
import correoService from "../services/correo.service";
import personaService from "../services/persona.service";

import { useConfirm } from "material-ui-confirm";

/**Material UI */
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from "@mui/material/IconButton";
import { DataGrid, esES } from '@mui/x-data-grid';
import { SnackbarProvider, useSnackbar } from 'notistack';


const AddCorreo = () => {
    const [correo, setCorreo] = useState('');
    const [correos, setCorreos] = useState([]);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [proyectos, setProyectos] = useState([]);
    const [cc, setCC] = useState([]);
    const confirm = useConfirm();
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        retreiveCorreos();
        retreiveCC();
    }, []);

    function retreiveCC() {
        personaService.getCC()
            .then(resp => {
                console.log(resp);
                setCC(resp.data);
            })
            .catch(err => {
                console.error(err);
            });
    }

    const handleProyecto = (e) => {
        console.log("E", e);
        if (e.target.checked) {
            proyectos.push({ nombre: e.target.value });
            setProyectos([...proyectos]);
        } else {
            var inx = proyectos.findIndex(proy => proy.nombre === e.target.value);
            if (inx >= 0) {
                proyectos.splice(inx, 1);
                setProyectos([...proyectos]);
            }
        }
        console.log("Proyectos", proyectos);
    }

    const handleChangeText = (valor, nombre) => {
        setCorreo({ ...correo, [nombre]: valor });
    }

    const ingresar = () => {
        if (!correo.destino) {
            alert("Debe ingresar un Destino");
            return;
        }
        for (var i in proyectos) {
            correoService.ingresar({ correo: correo.correo, destino: correo.destino, proyecto: proyectos[i].nombre })
                .then(resp => {
                    console.log(resp.data);
                    retreiveCorreos();
                    enqueueSnackbar("Correo agregado exitosamente!!", { variant: 'success' });
                })
                .catch(err => {
                    console.error(err);
                    enqueueSnackbar("Ha ocurrido un error!!", { variant: 'error' });
                });
        }
        if(proyectos.length === 0 && (correo.destino === "FINANZAS" || correo.destino === "FINANZAS2" || correo.destino === "FINANZAS3" || correo.destino === "GERENCIAGENERAL" || correo.destino === "JEFERRHH" || correo.destino === "CJARAMILLO" || correo.destino === "JEFERRLL")) {
            correoService.ingresar({ correo: correo.correo, destino: correo.destino })
                .then(resp => {
                    console.log(resp.data);
                    retreiveCorreos();
                    enqueueSnackbar("TCorreo agregado exitosamente!!", { variant: 'success' });
                })
                .catch(err => {
                    console.error(err);
                    enqueueSnackbar("Ha ocurrido un error!!", { variant: 'error' });
                });
        }
        /* correoService.ingresar(correo)
            .then(resp => {
                console.log(resp.data);
                retreiveCorreos();
            })
            .catch(err => {
                console.error(err);
            }); */
    }

    function retreiveCorreos() {
        correoService.getAll()
            .then(resp => {
                console.log("Data Correo", resp.data);
                setCorreos(resp.data);
            })
            .catch(err => {
                console.error(err);
            });
    }

    const eliminarCorreo = (row) => {
        //e.stopPropagation();
        console.log("ID", row.id);
        confirm({ description: `Esta seguro de eliminar el correo ${row.correo} para ${row.destino}!`, title: "Eliminar el correo?", confirmationText: "SI", cancellationText: "NO" })
            .then(() => {
                console.log("ID DEL CORREO", row.id);
                correoService.delete(row.id)
                    .then(resp => {
                        console.log(resp.data);
                        retreiveCorreos();
                    })
                    .catch(err => {
                        console.error(err);
                    });
            })
            .catch(() => {
                console.error("Error");
            });
    }

    const del_correo = (id) => {
        confirm({ description: "Esta seguro de eliminar el correo!", title: "Eliminar el correo?", confirmationText: "SI", cancellationText: "NO" })
            .then(() => {
                console.log("ID DEL CORREO", id);
            })
            .catch(() => {
                console.error("Error");
            });

    }

    const handleClose = () => {
        setConfirmOpen(false);
    };

    const columns = [{
        field: "correo", headerName: "Correo", flex: 1
    }, {
        field: "destino", headerName: "Destino", flex: 1
    }, {
        field: "proyecto", headerName: "Proyecto", flex: 1
    }, {
        field: "id", headerName: "Eliminar", flex: 1, renderCell: (cellValues) => {
            return (
                <div>
                    <IconButton aria-label="delete" onClick={() => eliminarCorreo(cellValues.row)}>
                        <DeleteIcon />
                    </IconButton>
                    <span>{cellValues.row.id}</span>
                    {/* <Button onClick={(e) => eliminarCorreo(e, cellValues.row)} variant='contained'>D</Button> */}
                    {/* <Dialog
                        open={confirmOpen}
                        onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            {"Use Google's location service?"}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Let Google help apps determine location. This means sending anonymous
                                location data to Google, even when no apps are running.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setConfirmOpen(false)}>Disagree</Button>
                            <Button onClick={(e) => eliminarCorreo(e, cellValues.row)} autoFocus>
                                Agree
                            </Button>
                        </DialogActions>
                    </Dialog> */}
                    {/* <AlertDialog
                        title="Eliminar el Correo?"
                        open={confirmOpen}
                        setOpen={setConfirmOpen}
                        onConfirm={() => del_correo(cellValues.row.id)}
                    >
                        Esta seguro de eliminar el Correo?
                    </AlertDialog> */}
                </div>
            )
        }
    }];

    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-4">
                    <div className="mb-3">
                        <label className="form-label">Destino:</label>
                        <select className="form-select" onChange={(e) => handleChangeText(e.target.value, "destino")}>
                            <option value="">Seleccione Destino ...</option>
                            <option value="FINANZAS">FINANZAS</option>
                            <option value="CJARAMILLO">CRISTIAN JARAMILLO</option>
                            <option value="FINANZAS2">FINANZAS2</option>
                            <option value="FINANZAS3">FINANZAS3</option>
                            <option value="JEFERRHH">JEFE RRHH</option>
                            <option value="JEFERRLL">JEFE RRLL</option>
                            <option value="RRHH">RRHH</option>
                            <option value="GERENCIA">GERENCIA</option>
                            <option value="GERENCIAGENERAL">GERENCIA GENERAL</option>
                        </select>
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Correo:</label>
                        <input type="text" className="form-control" onChange={(e) => handleChangeText(e.target.value, "correo")} />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Proyecto:</label>
                        {cc.map((item, i) => {
                            return (
                                <div className="form-check" key={i}>
                                    <input className="form-check-input" value={item.ctoDescripcion} type="checkbox" onChange={(e) => handleProyecto(e)} checked={proyectos.find(v => v.nombre === item.ctoDescripcion) ? true : false} />
                                    <label className="form-check-label">{item.ctoDescripcion}</label>
                                </div>
                            )
                        })}
                    </div>
                    <button className="btn btn-primary" onClick={ingresar}>Agregar</button>
                </div>
                <div className="col-md-8 p-3">
                    <div style={{ height: 450, width: '100%' }}>
                        <DataGrid
                            sx={{
                                boxShadow: 2,
                                border: 2,
                                borderColor: 'primary.light',
                                '& .MuiDataGrid-cell:hover': {
                                    color: 'primary.main',
                                },
                            }}
                            rows={correos ? correos : []}
                            columns={columns}
                            localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default function AddCorreoSnack() {
    return (
        <SnackbarProvider>
            <AddCorreo />
        </SnackbarProvider>
    )
}